<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_doc_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >NF inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_doc_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >NF final</label
              >
            </div>
          </b-col>
          <b-col sm="1" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nome_arquivo"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nome do arquivo</label
              >
            </div>
          </b-col>
          <b-col sm="1" md="2" class="p-a-0 m-t-5px">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                  type="text"
                  class="form-control"
                  v-model="nome_arquivo_original"
                  @keyup.enter="doFilter"
              />
              <label
                  class="fl-label"
                  for="default-input"
                  style="left: 13px; right: 12px"
              >Nome do arquivo original</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Inicial"
              reset-button
              show-decade-nav
              v-model="dt_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              placeholder="Data Final"
              reset-button
              show-decade-nav
              v-model="dt_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="status"
              :options="this.$parent.optionsStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Status"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
                v-model="layout"
                :options="this.$parent.optionsLayout"
                track-by="value"
                label="label"
                :hide-selected="true"
                placeholder="Arquivo"
                tag-placeholder="Selecionar"
                select-label="Selecionar"
                selected-label="Selecionado"
                deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      helpForm: new Form({
        params: [],
        search: "",
      }),
      num_doc_ini: "",
      num_doc_fim: "",
      nome_arquivo: "",
      nome_arquivo_original: "",
      dt_ini: "",
      dt_fim: "",
      status: "",
      layout: "",
      data_filter: [],
    };
  },
  mounted() {
    this.$events.$on("load-json", (e) => this.carregaJson());
  },
  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        num_doc_ini: this.num_doc_ini,
        num_doc_fim: this.num_doc_fim,
        nome_arquivo: this.nome_arquivo,
        nome_arquivo_original: this.nome_arquivo_original,
        status: this.status,
        layout: this.layout,
        dt_ini: this.formatDateSubmit(this.dt_ini),
        dt_fim: this.formatDateSubmit(this.dt_fim),
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.num_doc_ini = "";
      this.layout = "";
      this.dt_ini = "";
      this.dt_fim = "";
      this.nome_arquivo = "";
      this.nome_arquivo_original = "";
      this.$events.fire("filter-reset");
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>